<script setup lang="ts">

import { computed } from 'vue'

const props = defineProps<{
    firstCharacter: string
    width: string
}>()

const backgroundColor = computed(() => {
    return backgroundColorOptions[Math.floor(Math.random() * backgroundColorOptions.length)]
})

const fontSize = computed(() => {
    // Parse the width value and calculate 50% of it
    const widthValue = parseFloat(props.width)
    const unit = props.width.replace(widthValue.toString(), '')
    return `${widthValue * 0.5}${unit}`
})

const backgroundColorOptions = [
    '#000000', // Pure black
    '#1a1a1a', // Rich black
    '#8B0000', // Dark red
    '#B22222', // Fire brick
    '#DC143C', // Crimson
    '#FF4500', // Orange red
    '#FF6347', // Tomato
    '#FF8C00', // Dark orange
    '#FFA500', // Orange
    '#FFD700', // Gold
    '#9ACD32', // Yellow green
    '#32CD32', // Lime green
    '#228B22', // Forest green
    '#008000', // Green
    '#006400', // Dark green
    '#008B8B', // Dark cyan
    '#00CED1', // Dark turquoise
    '#1E90FF', // Dodger blue
    '#0000CD', // Medium blue
    '#000080', // Navy
    '#4B0082', // Indigo
    '#8A2BE2', // Blue violet
    '#9932CC', // Dark orchid
    '#8B008B', // Dark magenta
    '#FF1493'  // Deep pink
]

</script>

<template>
    <div :style="{ backgroundColor: backgroundColor, width: props.width, height: props.width }" class="default-profile-image-displayer">
        <p :style="{ fontSize: fontSize }">{{ props.firstCharacter }}</p>
    </div>
</template>

<style scoped lang="scss">

.default-profile-image-displayer{
    border-radius: 50%;
    background-color: #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.default-profile-image-displayer p{
    color: white;
    font-weight: 300;
    margin: 0;
}
</style>